<template>
  <div>
    <div class="nav-bar-box1">
      <div class="nav-bar-container">
        <div class="nav-bar-left">
          <img :src="getSetting.logo" alt style="height: 60px;" />
          <div class="nav-item1">
            <ul class="ul">
              <li
                :class="`li ${ $route.path === '/home' ? 'active' : '' }`"
                @click="$router.push('/home')"
              >{{ $hs('首页','Home','En la primera página') }}</li>
              <li
                :class="`li ${ ($route.path === '/product' || $route.path === '/newproduct') ? 'active' : '' }`"
                @click="goProduct"
              >{{ $hs('产品','Category','productos') }}</li>
              <li
                :class="`li ${ $route.path === '/about' ? 'active' : '' }`"
                @click="typeRap('about')"
              >{{ $hs('关于我们','About','Acerca de nosotros') }}</li>
              <li :class="`li ${ $route.path === '/news' ? 'active' : '' }`" @click="typeRap('news')">{{ $hs('博客/新闻','Blog','El blog') }}</li>
              <li
                :class="`li ${ $route.path === '/contact' ? 'active' : '' }`"
                @click="typeRap('contact')"
              >{{ $hs('联系我们','Contact Us','Contacta con nosotros') }}</li>
              <!-- <li :class="`li ${ $route.path === '/personal' ? 'active' : '' }`" @click="goPersonal">{{ $hs('个人中心','Personal Center') }}</li> -->
            </ul>
          </div>
        </div>
        <div style="display: flex;">
          <div>
            <img
              src="../../assets/LLH_follow/serch.png"
              alt
              style="width: 36px;height: 36px;margin-right: 12px;cursor: pointer;"
              @click="getsercher"
            />
          </div>
          <div class="cart">
            <img
              src="../../assets/LLH_follow/shappcar.png"
              alt
              style="width: 36px;height: 36px;margin-right: 12px;cursor: pointer;"
              @click="goCart"
            />
            <div class="cart-num">{{ userInfo.id ? gettingCart.length : getEnquiry[0].list.length }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="nav-bar-box">
      <div class="container nav-box">
        <div class="nav-item">
          <ul class="ul">
            <li :class="`li ${ $route.path === '/home' ? 'active' : '' }`" @click="$router.push('/home')">{{ $hs('首页','Home') }}</li>
            <li
              :class="`li ${ ($route.path === '/product' || $route.path === '/newproduct') ? 'active' : '' }`"
              @click="goProduct"
            >{{ $hs('产品','Product Display') }}</li>
            <li :class="`li ${ $route.path === '/news' ? 'active' : '' }`" @click="$router.push('/news')">{{ $hs('新闻','News') }}</li>
            <li :class="`li ${ $route.path === '/about' ? 'active' : '' }`" @click="$router.push('/about')">{{ $hs('关于我们','About Us') }}</li>
            <li
              :class="`li ${ $route.path === '/contact' ? 'active' : '' }`"
              @click="$router.push('/contact')"
            >{{ $hs('联系我们','Contact Us') }}</li>
            <li :class="`li ${ $route.path === '/personal' ? 'active' : '' }`" @click="goPersonal">{{ $hs('个人中心','Personal Center') }}</li>
          </ul>
        </div>
      </div>
      <login-modal ref="loginModal" @register="register"></login-modal>
      <register-model ref="registerModel" @login="login"></register-model>
    </div>-->
    <login-modal ref="loginModal" @register="register" @forgetpassword="forgetpassword"></login-modal>
    <register-model ref="registerModel" @login="login"></register-model>
    <comprehensive-query ref="comprehensivequery" @login="login"></comprehensive-query>
    <reset-pass-model ref="resetPassModel" @login="login"></reset-pass-model>
  </div>
</template>

<script>
import loginModal from '@/components/memberModal/loginModal.vue'
import registerModel from '@/components/memberModal/registerModel.vue'
import ComprehensiveQuery from '@/components/memberModal/comprehensivequery.vue'
import resetPassModel from '@/components/memberModal/resetPassModel.vue'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'navBar',
  components: {
    loginModal,
    registerModel,
    ComprehensiveQuery,
    resetPassModel
  },
  props: {
    tabHeight: {
      type: Number,
      default: 60
    },
    menuBackground: {
      type: String,
      default: '#fe6a00'
    },
    textColor: {
      type: String,
      default: '#00923f'
    },
    activetextColor: {
      type: String,
      default: '#00923f'
    },
    hasSearchInput: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      keywords: '',
      active: this.$route.path
    }
  },
  watch: {
    $route: {
      handler() {
        this.active = this.$route.path
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('setting', {
      getMenus: 'get_menus',
      getSetting: 'get_setting',
    }),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),
    ...mapState('user', ['userInfo'])
  },
  methods: {
    // 登录
    login() {
      this.$refs.loginModal.open()
    },

    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    goPersonal() {
      if (!this.userInfo.id) {
        this.login()
      } else {
        this.$router.push('/personal')
      }
    },
    // 跳转购物车
    goCart() {
      this.getScrollTop();
      if (!this.userInfo.id) {
        this.login()
      } else {
        this.$router.push({ path: '/cart' })
      }
    },
    getsercher() {
      this.getScrollTop();
      this.$refs.comprehensivequery.open()
    },
    // 打开忘记密码
    forgetpassword() {
      this.$refs.resetPassModel.open()
    },
    getScrollTop() {
      localStorage.setItem('scrollTop', JSON.stringify(0))
    },
    typeRap(typeLin) {
      this.getScrollTop();
      if (typeLin == 'about') {
        this.$router.push('/about');
      } else if (typeLin == 'news') {
        this.$router.push('/news')
      } else if (typeLin == 'contact') {
        this.$router.push('/contact')
      }
    },
    // 跳转产品页
    goProduct() {
      this.getScrollTop();
      if (this.$route.path === '/product') {
        location.reload()
      } else {
        this.$router.push('/product')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-bar-box1 {
  margin-top: 62px;
  width: 100%;
  .nav-bar-container {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }
  .nav-bar-left {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .nav-item1 {
    ul {
      display: flex;
      justify-content: space-between;
      li {
        height: 100%;
        padding: 0 15px;
        line-height: 58px;
        font-size: 16px;
        color: #222;
        list-style: none;
        transition-duration: 0.5s;
        text-align: center;
        border-radius: 10px 10px 0 0;
        margin: 2px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
          color: #e33c0b;
        }
      }

      .active {
        color: #e33c0b;
      }
    }
  }
  .cart {
    position: relative;
    width: 45px;
    height: 45px;
  }
  .cart-num {
    position: absolute;
    padding: 1px 6px;
    height: 20px;
    background: #e33c0b;
    font-size: 15px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    top: 0;
    right: 0;
  }
}
.nav-bar-box {
  width: 100%;
  height: 100px;
  .nav-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .nav-item {
      flex: 1;
      height: 60px;
      ul {
        display: flex;
        justify-content: space-between;
        li {
          flex: 1;
          height: 100%;
          line-height: 58px;
          padding: 0 30px;
          font-size: 16px;
          color: #222;
          transition-duration: 0.5s;
          text-align: center;
          border-radius: 10px 10px 0 0;
          margin: 2px;
          overflow: hidden; /* 确保超出的内容被裁剪 */
          white-space: nowrap; /* 确保文本在一行内显示 */
          text-overflow: ellipsis; /* 使用省略号表示超出的文本 */
          box-sizing: border-box;
          &:hover {
            cursor: pointer;
            color: #222;
            // transform: scale(1.2);
            background: #ebffef;
          }
        }

        .active {
          color: #fff;
          background: #00923f;

          &:hover {
            color: #fff;
            // transform: scale(1.2);
            background: #00923f;
          }
        }
      }
    }
  }
}
</style>